














import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class BigPromotion extends Vue {
  @Prop({ default: () => ({}) }) readonly bigPromotion!: any

  get show() {
    const { iconUrl, iconUrl2, iconUrl3 } = this.bigPromotion || {}
    return iconUrl && iconUrl2 && iconUrl3
  }
}
